<template>
  <div class="home">
    <div class="topBox" :style="{ backgroundImage: 'url(' + bgUrl + ')' }">
      <!-- <Header /> -->
      <div class="title">
        <!-- <template v-if="getOne">
          <div>{{ titleObj.top }}</div>
          <div>{{ titleObj.bottom }}</div>
        </template> -->
      </div>
      <div class="recommendCard" v-if="getOne">
        <div class="shopTitle">
          {{ getOne.orgName || getOne.orgNameShow }}
          <span class="distance" v-if="getOne.distance || getOne.distance === 0"
            >距您{{ getOne.distance && getOne.distance.toFixed(2) }}km</span
          >
        </div>
        <div class="line"></div>
        <div class="detail">
          {{ getOne.address || getOne.addressCn }}
          <span
            class="consulMap"
            @click="
              lookMap({
                cnLatitude: getOne.cnLatitude,
                cnLongitude: getOne.cnLongitude,
              })
            "
            >查看地图</span
          >
        </div>
        <div class="timeBox">
          <span class="time">{{ getOne.operatingHour }}</span>
          <div class="phoneBox">
            <img class="phone" src="@/assets/phone.png" alt />
            <a class="a" :href="'tel:' + getOne.phone">{{ getOne.phone }}</a>
          </div>
        </div>
        <div class="btnBox" @click="goDetail(getOne, -1)">
          <img class="btn" src="@/assets/btn.png" alt />
          <img
            class="hand"
            v-show="cilickIndex == -1"
            src="@/assets/hand.png"
            alt
          />
        </div>
      </div>
      <div class="recommendCard" v-else>
        <div class="no-title">
          <div>无法获取您当前所在地</div>
          <div>请选择城市再为您推荐</div>
        </div>
      </div>
    </div>

    <div class="regionBox">
      <div class="header">
        <div class="region" @click="showPicker = true">
          {{ selValue[0] }}
          <img src="@/assets/down.png" alt />
        </div>
        <div class="region" @click="showPicker = true">
          {{ selValue[1] }}
          <img src="@/assets/down.png" alt />
        </div>
        <div class="serch" @click="showPicker = true">切换城市</div>
      </div>
      <div class="shopBox">
        <div
          class="shopItem"
          v-for="(shop, i) in getByProvinceAndCity"
          :key="i"
        >
          <div class="shopTitleBox">
            <img class="addressIcon" src="@/assets/addressIcon.png" alt />
            <span class="shopTitle">{{
              shop.orgName || shop.orgNameShow
            }}</span>
            <span class="distance" v-if="shop.distance || shop.distance === 0"
              >距您{{ shop.distance.toFixed(2) }}km</span
            >
            <div class="phoneBox">
              <img class="phone" src="@/assets/phone.png" alt />
              <a class="a" :href="'tel:' + shop.phone">{{ shop.phone }}</a>
            </div>
          </div>
          <div class="detail">
            {{ shop.address || shop.addressCn }}
            <span
              class="consulMap"
              @click="
                lookMap({
                  cnLatitude: shop.cnLatitude,
                  cnLongitude: shop.cnLongitude,
                })
              "
              >查看地图</span
            >
          </div>
          <div class="timeBox">
            <span class="time">{{ shop.operatingHour }}</span>
          </div>
          <!-- {{shop.brandCode}} -->
          <div class="btnBox" @click="goDetail(shop, i)">
            <img class="btn" src="@/assets/btn.png" alt />
            <img
              class="hand"
              v-show="cilickIndex == i"
              src="@/assets/hand.png"
              alt
            />
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        @change="onChange"
      />
    </van-popup>
  </div>
</template>

<script>
// import Header from "@/components/Header.vue";
// import region from "@/public/Address.js";

// var map = new BMap.Map("allmap");
// var point = new BMap.Point(116.331398, 39.897445);
// map.centerAndZoom(point, 12);
// var mk = new BMap.Marker(r.point);
// map.addOverlay(mk);
// map.panTo(r.point);
var geolocation = new BMap.Geolocation();

// var geolocation = new qq.maps.Geolocation(
//   "BIABZ-4APR3-ZJ33Q-YTVIJ-GT32Z-N4BRH",
//   "周生生-用户点击"
// );
let errrun = false;
let successrun = false;
function watchPosition (errBack, successBack) {
  geolocation.watchPosition(data => {
    console.log("监听到定位成功了", data);
    geolocation.clearWatch();
    if (!successrun && (data.lat || data.lat == 0)) {
      successrun = true;
      successBack(data);
    }
    console.log("successBack");
  });
}

export default {
  name: "Home",
  components: {
    // Header
  },
  data () {
    return {
      areaCode: this.$route.params.area,
      brandType: this.$route.params.brands,
      showPicker: false,
      columns: [
        {
          values: [],
          defaultIndex: 0
        },
        {
          values: [],
          defaultIndex: 0
        }
      ],
      selValue: ["", ""],
      getByProvinceAndCity: [],
      getOne: null,
      userLocation: {},
      getLocation: {},
      cilickIndex: -2,
      // titleObj: {
      //   top: "离您最近的门店珠宝顾问",
      //   bottom: "已准备好为您服务"
      // },
      bgUrlArr: [
        {
          brand: 'CSS',
          bgUrl: require('../assets/css-bg.png')
        },
        {
          brand: 'PRO',
          bgUrl: require('../assets/pro-bg.jpg')
        },
        {
          brand: 'EMP',
          bgUrl: require('../assets/emp-bg.jpg')
        },
        {
          brand: 'MB',
          bgUrl: require('../assets/mb-bg.png')
        },
        {
          brand: 'MG',
          bgUrl: require('../assets/mg-bg.png')
        }
      ],

      bgUrl: ''
    };
  },
  async created () {
    // return;
    await this.$api.user.getToken({
      userId: "cssUat",
      clientId: "cssUat1"
    });
    this.getCurrentPosition();
    // geolocation.getLocation(
    //   res => {
    //     console.log("getLocation成功了", res);
    //     this.successBack(res);
    //   },
    //   err => {
    //     console.log("getLocation失败了111", err);
    //     var ua = navigator.userAgent.toLowerCase();
    //     this.errBack();
    //     watchPosition(this.errBack, this.successBack);
    //   },
    //   { timeout: 10 }
    // );
    // }, 500);
    // this.getProvinceAndCity();
  },
  activated () { },
  deactivated () {
    clearTimeout(this.timeOut);
  },
  beforeDestroy () {
    clearTimeout(this.timeOut);
  },
  methods: {
    getCurrentPosition (runBack = true) {
      let that = this;
      geolocation.getCurrentPosition(
        function (r) {
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            if (r.address.district) {
              let data = {
                lat: r.point.lat,
                lng: r.point.lng,
                city: r.address.city,
                province: r.address.province
              };
              that.successBack(data);
            } else {
              runBack && that.errBack();
              that.timeOut = setTimeout(() => {
                that.getCurrentPosition(false);
              }, 1000);
            }
          } else {
            runBack && that.errBack();
          }
        },
        { enableHighAccuracy: true }
      );
    },
    errBack () {
      // this.titleObj = {
      //   top: "无法获取您当前所在地",
      //   bottom: "请选择城市再为您推荐"
      // };

      this.selValue = ["北京", "北京市"];
      let virtualLocation = {
        province: "北京",
        city: "北京市",
      }
      this.getLocation = virtualLocation
      this.getAll(virtualLocation);
    },
    successBack (data) {
      // this.titleObj = {
      //   top: "离您最近的门店珠宝顾问",
      //   bottom: "已准备好为您服务"
      // };
      this.getCity(data);
    },
    // 默认选中
    defaultChoose () {
      this.getProvinceAndCity().then(res => {
        this.getProvinceAndCityArr = res
        //第一列
        let _firstValue = Object.keys(this.getProvinceAndCityArr)
        let _firstIndex = _firstValue.findIndex(v => v == this.selValue[0])

        let _secondValue = [], _secondIndex = 0, virtualLocation = {}
        // 第二列
        if (_firstIndex > -1) {
          _secondValue = this.getProvinceAndCityArr[_firstValue[_firstIndex]]
          _secondIndex = _secondValue.findIndex(v => v == this.selValue[1])
          if (_secondIndex < 0) _secondIndex = 0;
        } else {
          _firstIndex = 0
          _secondValue = this.getProvinceAndCityArr[_firstValue[_firstIndex]]
          _secondIndex = 0
          this.selValue = [_firstValue[0], _secondValue[0]]
        }


        this.columns = [
          {
            values: _firstValue,
            defaultIndex: _firstIndex
          },
          {
            values: _secondValue,
            defaultIndex: _secondIndex
          }
        ]

        if ((this.getLocation.province !== _firstValue[_firstIndex]) || (this.getLocation.city !== _secondValue[_secondIndex])) {
          // console.log('---->', this.getLocation.province, _firstValue[_firstIndex], this.getLocation.city, _secondValue[_secondIndex])
          virtualLocation = {
            province: _firstValue[_firstIndex],
            city: _secondValue[_secondIndex],
            lat: this.getLocation.lat,
            lng: this.getLocation.lng
          }
          this.getAll(virtualLocation, false);
        }
        // console.log(this.getLocation)

      })


    },
    //获取省市
    async getProvinceAndCity () {

      let _data = {}
      if (this.areaCode) {
        _data = {
          areaCode: this.areaCode
        }
      } else if (this.brandType) {
        _data = {
          brandType: this.brandType.toUpperCase()
        }
      }

      let getProvinceAndCityArr = await this.$api.user.getProvinceAndCity(_data);

      let keys = Object.keys(getProvinceAndCityArr)
      keys.forEach(key=>{
        if(getProvinceAndCityArr[key].length == 0){
          Reflect.deleteProperty(getProvinceAndCityArr,key)
        }
      })
      if(getProvinceAndCityArr['香港']){
        getProvinceAndCityArr['香港'].splice(getProvinceAndCityArr['香港'].indexOf('中西区'),1)
      }
      return getProvinceAndCityArr;
    },
    async getCity (getLocation) {
      let shopInfo = await this.$api.user.getAll({
        area: this.areaCode,
        cnLatitude: getLocation.lat || "",
        cnLongitude: getLocation.lng || "",
        city: "",
        province: ""
      });
      this.selValue = [shopInfo.getOne[0].province, shopInfo.getOne[0].city];
      getLocation.province = shopInfo.getOne[0].province;
      getLocation.city = shopInfo.getOne[0].city;
      this.getLocation = getLocation;
      this.getAll(getLocation);
    },
    async getAll (getLocation = {}, flag = true,) {
      let shopInfo;
      console.log(this.$route.path)
      if (this.$route.path === '/') {
        // 全部大陆门店
        shopInfo = await this.$api.user.getAllInland({
          area: this.areaCode,
          cnLatitude: getLocation.lat || "",
          cnLongitude: getLocation.lng || "",
          city: getLocation.city || "",
          province: getLocation.province || ""
        });
      } else if (this.$route.path === '/brand-css') {
        // css 大陆门店
        shopInfo = await this.$api.user.getCss({
          area: this.areaCode,
          cnLatitude: getLocation.lat || "",
          cnLongitude: getLocation.lng || "",
          city: getLocation.city || "",
          province: getLocation.province || ""
        });
      } else if (this.$route.path === '/brand-es') {
        // css 大陆门店
        shopInfo = await this.$api.user.getEs({
          area: this.areaCode,
          cnLatitude: getLocation.lat || "",
          cnLongitude: getLocation.lng || "",
          city: getLocation.city || "",
          province: getLocation.province || ""
        });
      } else if (this.$route.path === '/brand-mg') {
        // mg 大陆门店
        shopInfo = await this.$api.user.getMg({
          area: this.areaCode,
          cnLatitude: getLocation.lat || "",
          cnLongitude: getLocation.lng || "",
          city: getLocation.city || "",
          province: getLocation.province || ""
        });
      } else if (this.$route.path === '/brand-pro') {
        // pro 大陆门店
        shopInfo = await this.$api.user.getPro({
          area: this.areaCode,
          cnLatitude: getLocation.lat || "",
          cnLongitude: getLocation.lng || "",
          city: getLocation.city || "",
          province: getLocation.province || ""
        });
      } else if (this.$route.path === '/brand-cssmg') {
        // css mg 大陆门店
        shopInfo = await this.$api.user.getCssMg({
          area: this.areaCode,
          cnLatitude: getLocation.lat || "",
          cnLongitude: getLocation.lng || "",
          city: getLocation.city || "",
          province: getLocation.province || ""
        });
      } else if (this.$route.path === '/brand-cssmb') {
        // css mb 大陆门店
        shopInfo = await this.$api.user.getCssMb({
          area: this.areaCode,
          cnLatitude: getLocation.lat || "",
          cnLongitude: getLocation.lng || "",
          city: getLocation.city || "",
          province: getLocation.province || ""
        });
      } else if (this.$route.path === '/brand-csspro') {
        // css pro 大陆门店
        shopInfo = await this.$api.user.getCssPro({
          area: this.areaCode,
          cnLatitude: getLocation.lat || "",
          cnLongitude: getLocation.lng || "",
          city: getLocation.city || "",
          province: getLocation.province || ""
        });
      } else if (this.$route.path === '/brand-cssmgpro') {
        // css mg pro 大陆门店
        shopInfo = await this.$api.user.getCssMgPro({
          area: this.areaCode,
          cnLatitude: getLocation.lat || "",
          cnLongitude: getLocation.lng || "",
          city: getLocation.city || "",
          province: getLocation.province || ""
        });
      } else if (this.$route.path === '/brand-cssmbpro') {
        // css mb pro 大陆门店
        shopInfo = await this.$api.user.getCssMbPro({
          area: this.areaCode,
          cnLatitude: getLocation.lat || "",
          cnLongitude: getLocation.lng || "",
          city: getLocation.city || "",
          province: getLocation.province || ""
        });
      } else {
        // area区域门店
        shopInfo = await this.$api.user.getByArea({
          area: this.areaCode,
          cnLatitude: getLocation.lat || "",
          cnLongitude: getLocation.lng || "",
          city: getLocation.city || "",
          province: getLocation.province || ""
        });
      }
      this.getOne = shopInfo.getOne ? shopInfo.getOne[0] : null;
      if (this.getOne && flag) this.selValue = [shopInfo.getOne[0].province, shopInfo.getOne[0].city];
      if (flag) this.defaultChoose();

      this.getByProvinceAndCity = shopInfo.getByProvinceAndCity;
      let _siteStyle = shopInfo.siteStyles !== 'null' ? shopInfo.siteStyles : 'CSS'
      let _item = this.bgUrlArr.filter(v => v.brand == _siteStyle)
      this.bgUrl = _item[0].bgUrl


      // 上报微信登陆数据
      this.weixinOAuth2(getLocation);
    },
    onChange (picker, values) {
      let { getProvinceAndCityArr } = this;
      picker.setColumnValues(1, getProvinceAndCityArr[values[0]]);

    },
    onConfirm (value) {
      this.selValue = value;
      this.showPicker = false;
      this.search()
    },
    search () {
      let { selValue, getLocation } = this;
      getLocation.province = selValue[0];
      getLocation.city = selValue[1];
      this.getAll(getLocation, false);
    },
    goDetail (data, index) {
      // console.log('----------->>>', data)
      _hmt.push(["_trackEvent", "首页顾问按钮", "点击", data.orgName, data.id]);
      this.cilickBtn(index);
      this.$router.push({
        name: "Card",
        query: {
          orgCode: data.orgCode || data.orgCodeSidm,
          address: data.address,
          addressCn: data.addressCn,
          brandCode: data.brandCode,
          orgName: data.orgName || data.orgNameShow,
          orgNameCn: data.orgNameCn
        }
      });
    },
    cilickBtn (index) {
      clearTimeout(this.clearT);
      this.cilickIndex = index;
      this.clearT = setTimeout(() => {
        this.cilickIndex = -2;
      }, 500);
    },
    lookMap (query) {
      let { cnLatitude, cnLongitude } = query;
      if (
        (!cnLatitude && cnLatitude !== 0) ||
        (!cnLongitude && cnLongitude !== 0)
      ) {
        this.$toast("暂无该店位置信息");
        return;
      }
      if (cnLatitude > 90) {
        [cnLatitude, cnLongitude] = [cnLongitude, cnLatitude];
      }
      this.$router.push({
        name: "map",
        query: {
          cnLatitude: Number(cnLatitude),
          cnLongitude: Number(cnLongitude)
          // cnLatitude: 31.18826,
          // cnLongitude: 121.43687
        }
      });
    },
    /**
     * @author yihan.zhang
     * 微信登陆，提交code与state
     * @returns {Promise<void>}
     */
    async weixinOAuth2 (getLocation = {}) {
      // 判断是否在微信中
      let code = localStorage.getItem("WEIXIN_OAUTH2_CODE");
      let state = localStorage.getItem("WEIXIN_OAUTH2_STATE");
      localStorage.removeItem('WEIXIN_OAUTH2_CODE');
      localStorage.removeItem('WEIXIN_OAUTH2_STATE');
      if (code && state) {
        // 保存用户信息
        console.log('提交微信用户数据中', code, state, getLocation);
        localStorage.setItem("WEIXIN_OAUTH2_IS", "TRUE");
        result = await this.$api.user.saveWeixinUser({
          code: code,
          state: state,
          cnLatitude: getLocation.lat || "",
          cnLongitude: getLocation.lng || "",
          city: getLocation.city || "",
          province: getLocation.province || ""
        })
        console.log('微信用户信息保存结果', result);
      }
    },
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  min-height: 100vh;
  display: flex;
  flex-flow: column wrap;
  .topBox {
    flex: none;
    // background-image: url("../assets/css-bg.png");
    background-repeat: no-repeat;
    background-size: 100%;
    // background-position: 0px 0.78rem;
    padding-top: 1rem;
  }
  .title {
    margin-top: 1.3rem;
    margin-bottom: 0.84rem;
    text-align: center;
    font-size: 0.33rem;
    font-weight: bold;
    color: rgba(157, 149, 114, 1);
    line-height: 0.56rem;
    height: 1.12rem;
    letter-spacing: 0.13rem;
    .titleImg {
      width: 5.02rem;
    }
  }
  .phoneBox {
    width: 0.37rem;
    height: 0.37rem;
    position: relative;
    font-size: 0;
    .phone {
      width: 0.37rem;
      height: 0.37rem;
    }
    .a {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }
  }
  .recommendCard {
    width: 6.18rem;
    min-height: 3.34rem;
    box-shadow: 0.03rem 0.03rem 0.12rem 0px rgba(4, 4, 4, 0.25);
    margin: 0.84rem auto 1.07rem auto;
    padding: 0.34rem 0.39rem 0.31rem 0.4rem;
    position: relative;
    background: white;
    .no-title {
      margin: 0.8rem 0 0;
      text-align: center;
      font-size: 0.33rem;
      font-weight: bold;
      color: rgba(157, 149, 114, 1);
      line-height: 0.56rem;
      height: 1.12rem;
      letter-spacing: 0.13rem;
    }
    .shopTitle {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      font-size: 0.36rem;
      font-weight: 400;
      // word-break: break-all;
      color: rgba(0, 0, 0, 1);
      .distance {
        font-size: 0.22rem;
        font-weight: 400;
        color: rgba(128, 128, 128, 1);
        flex: none;
      }
    }
    .line {
      margin-top: 0.25rem;
      width: 3.22rem;
      height: 2px;
      background-color: rgba(128, 128, 128, 0.2);
    }
    .detail {
      font-size: 0.25rem;
      font-weight: 400;
      color: rgba(128, 128, 128, 0.7);
      line-height: 0.38rem;
      margin-top: 0.29rem;
      .consulMap {
        font-size: 0.22rem;
        font-weight: 400;
        color: rgba(197, 189, 152, 1);
        text-decoration: underline;
      }
    }
    .timeBox {
      font-size: 0.22rem;
      font-weight: 400;
      color: rgba(128, 128, 128, 0.7);
      display: flex;
      align-items: center;
      .phoneBox {
        margin-left: 0.1rem;
      }
    }
    .btnBox {
      position: relative;
      // right: 0.61rem;
      // bottom: 0.31rem;
      height: 0.46rem;
      font-size: 0;
      margin-top: 0.05rem;
      .btn {
        width: 2.24rem;
        height: 0.46rem;
        position: absolute;
        right: 0;
        top: 0;
      }
      .hand {
        width: 0.44rem;
        height: 0.46rem;
        position: absolute;
        right: -0.2rem;
        bottom: -0.2rem;
        z-index: 2;
      }
    }
  }
  .regionBox {
    // flex: 1;
    width: 7.5rem;
    padding: 0 0.67rem;
    display: flex;
    flex-flow: column wrap;
    background-color: #fff;
    // height: 4.67rem;
    .header {
      height: 0.6rem;
      padding: 0 0.24rem 0 0.29rem;
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgba(0, 0, 0, 0.2);
      border-top: 1px solid rgba(0, 0, 0, 0.2);
      // flex: none;
      .region {
        font-size: 0.22rem;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.9);
        flex: 1;
        img {
          width: 0.16rem;
          height: 0.09rem;
          display: inline-block;
          margin-left: 0.12rem;
        }
      }
      .serch {
        width: 1.23rem;
        height: 0.35rem;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 0.03rem;
        font-size: 0.22rem;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .shopBox {
      margin-top: 0.32rem;
      // flex: 1;

      // overflow-y: scroll;
      // height: 3.77rem;

      .shopItem {
        padding: 0.22rem 0.24rem 0.4rem 0.31rem;
        .shopTitleBox {
          display: flex;
          align-items: baseline;
          .addressIcon {
            width: 0.19rem;
            height: 0.28rem;
            display: inline-block;
            margin-right: 0.17rem;
            flex: none;
          }
          .shopTitle {
            font-size: 0.31rem;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            flex: 1;
            display: inline-block;
            margin-right: 0.17rem;
          }
          .distance {
            font-size: 0.22rem;
            font-weight: 400;
            color: rgba(128, 128, 128, 1);
            text-align: center;
            margin-right: 0.2rem;
          }
          .phoneBox {
            flex: none;
            position: relative;
            top: 0.08rem;
          }
        }
        .detail {
          font-size: 0.22rem;
          font-weight: 400;
          color: rgba(128, 128, 128, 0.7);
          line-height: 0.38rem;
          margin-top: 0.29rem;
          .consulMap {
            font-size: 0.22rem;
            font-weight: 400;
            color: rgba(197, 189, 152, 1);
            text-decoration: underline;
          }
        }
        .timeBox {
          font-size: 0.22rem;
          font-weight: 400;
          color: rgba(128, 128, 128, 0.7);
        }
        .btnBox {
          text-align: right;
          font-size: 0;
          margin-top: 0.05rem;
          position: relative;
          .btn {
            width: 2.24rem;
            height: 0.46rem;
          }
          .hand {
            width: 0.44rem;
            height: 0.46rem;
            position: absolute;
            right: -0.2rem;
            bottom: -0.2rem;
            z-index: 2;
          }
        }
      }
    }
  }
}
</style>
